import { IBulkOperationConfigInterface } from '../../bulk-operation/interfaces/bulk-operation.interface';
import { IKeyElement, TableItemInterface } from './table-item.interface';
import { ITablelistActionConfig } from './tablelist-action.config.interface';

export interface ITablelistStateListItemConfig {
  id: string;
  actions: ITablelistActionConfig;
  additionalResourcesToRetrieve?: any[];
  associationItems?: any[];
  chunkSize?: number;
  condition?: IKeyElement;
  dynamicSearch?: { };
  exportData?: { };
  fetchAdditionalData?: boolean;
  filterable?: boolean;
  maxItemsPerPage?: number;
  name: string;
  numberOfChunkSizeForSearch: number;
  payload?: any;
  queryType?: string;
  redirectUrl?: string;
  resource: string;
  resourceType?: string;
  resourceTypeCode: string;
  resources: string[];
  searchPlaceholderText?: string;
  simpleSearch?: { };
  sortByField?: string;
  sortByOrder?: number;
  sortOrder?: string | number;
  table: TableItemInterface[];
  title?: string;
  trackByField: string;
  type?: string;
  tableStateEnabled?: boolean;
  bulkOperations?: IBulkOperationConfigInterface;
}

export interface ITablelistStateListItem {
  ids: Array<string>;
  amount: number;
  config: ITablelistStateListItemConfig;
  data: Array<any>;
  items?: any[];
  loaded: boolean;
  identifierData: object;
}

export interface ITablelistStateItem {
  [id: string]: ITablelistStateListItem;
}
